// eslint-disable-next-line import/prefer-default-export
export const getLocale = state => state.getIn(['i18n', 'locale']);
